<script lang="ts" setup>
import { Link, usePage } from "@inertiajs/vue3";
import { computed } from "vue";

const page = usePage();

interface Props {
  href?: string;
}

const props = defineProps<Props>();

const component = computed<string | typeof Link>(() => {
  if (!props.href) {
    return "div";
  }

  return props.href.startsWith(page.props.ziggy.url) ? Link : "a";
});
</script>

<template>
  <component
    :is="component"
    :data-card-hover="true"
    :href="href"
    :target="component === 'a' ? '_blank' : null"
    class="block cursor-pointer"
  >
    <slot />
  </component>
</template>

<style scoped>
a {
  @apply border-b-0;
}
</style>
